<span class="site-filter-menu" *ngIf="shouldDisplay">
  <button [matMenuTriggerFor]="filterMenu" mat-stroked-button color="accent" class="btn-filter" [ngClass]="{'btn-filter-active': filterBtnActive}"><span class="title">{{filterMenuData.name}}</span><span class="num" *ngIf="filterBtnActive">{{'(' + activeItemCount + ')'}}</span></button>
  <mat-menu #filterMenu="matMenu" class="filter-menu" [class]="isSpanish ? 'filter-custome-menu-es filter-menu' : 'filter-menu'">
    <mat-icon class="close-filter link" (click)="closeFilterMenu()">close</mat-icon>
    <div class="filter-menu-content">
      <div (click)="$event.stopPropagation()">
        <h5 class="no-margin">{{filterMenuData.name}}</h5>
        <mat-form-field class="custome-class-close">
          <mat-label [innerHTML]="'$lng_adm_tit16_s1' | translate"></mat-label>
          <input matInput type="search" placeholder="search" [formControl]="itemSearchControl">
          <span class="searchhiddenToolTip">
            <mat-icon matSuffix>search</mat-icon>
            <span class="search-download-tool-tip" [innerHTML]="'$common_search' | translate"></span>
          </span>
        </mat-form-field>
        <div class="user-defined-values" [formGroup]="filterItemForm">
          <mat-checkbox class="user-value"  
            *ngFor="let item of filterMenuData.items | filterSiteFilterItems : itemSearchControl.value"
            [formControlName]="item.id">{{item.name}}</mat-checkbox>
        </div>
      </div>
      <div class="row actions">
        <div class="col-xs" (click)="$event.stopPropagation()"><button mat-button class="link clear-filters" (click)="clearallFilter()" [innerHTML]="'$site_filter_reset_button' | translate"></button></div>
        <div class="col-xs end-xs"><button mat-button class="link" (click)="customFilterActive()" [innerHTML]="'$site_filter_apply_button' | translate"></button></div>
      </div>
    </div>
  </mat-menu>
</span>